customElements.define('frequently-bought', class frequentlyBought extends HTMLElement {
    constructor() {
      super();
      this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      this.submitButton = this.querySelector(".submit-button");
      if (!this.submitButton) return; this.submitButton.addEventListener("click", this.addToCart.bind(this));
    }

    addToCart(evt) {
      const atcData = JSON.parse(this.querySelector('#frequentlyBought').textContent);

      if (atcData) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.setAttribute('disabled', true);
        this.submitButton.classList.add('loading');

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(atcData)
        })
        .then(response => {
          return response.json()
        })
        .then(data => {
          if (data.status) {
            this.handleErrorMessage(data.description);
          } else {
            this.cart.renderContents(data);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled'); this.submitButton.removeAttribute('disabled');
        });
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }
);